var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('iframe',{staticClass:"layout",attrs:{"src":"https://voccard.liveabc.com/learningpro_toeic/","frameborder":"0"}})])])
}]

export { render, staticRenderFns }